<!-- @format -->

@if (inStorePickupButtonText$ | async; as inStorePickupButtonText) {
	<div id="pdp-in-store-pickup-button">
		<pdp-add-to-cart-component-fulfillment-button
			#fulfillmentButton
			class="dynamic-fill"
			[isDisabled]="inStorePickupButtonText.fulfillmentButtonDisabledClass"
			[isSelected]="(shipMode$ | async) === 'bopis' || (shipMode$ | async) === 'bopl'"
			(buttonClicked)="setShipMode(inStorePickupButtonText.isBopl)">
			<homefield-icon
				class="fulfillment-icon"
				width="36px"
				height="36px"
				[name]="fulfillmentIconName">
			</homefield-icon>
			<span fulfillment-type-label>{{ inStorePickupButtonText.fulfillmentButtonLabel }}</span>
			<span
				fulfillmentText
				class="hmf-display-flex hmf-flex-col">
				{{ inStorePickupButtonText.fulfillmentButtonText }}
				@if (inStorePickupButtonText.changeStoreButtonText) {
					@if (!nearbyStoresButtonEnabled()) {
						<pdp-feature-change-store-button
							class="hmf-px-0"
							[productSkusPartNumber]="productSkusPartNumber$ | async"
							[resolvedSkuId]="resolvedSkuId$ | async"
							[dataEm]="inStorePickupButtonText.changeStoreButtonDataEm">
							<span
								id="in-store-pickup-button-change-store"
								[ngClass]="{ 'hmf-body-s hmf-body-md-m': true }">
								{{ inStorePickupButtonText.changeStoreButtonText }}
							</span>
						</pdp-feature-change-store-button>
					} @else {
						<span class="hmf-body-m label-secondary-subtle-static">
							{{ inStorePickupButtonText.changeStoreButtonText }}
						</span>
					}
				}
			</span>
		</pdp-add-to-cart-component-fulfillment-button>
	</div>
}
